import * as React from 'react';
import '../../../../Loader/SkeletonV3/index.js';
import { useIconLoadingContainer } from './hooks/useIconLoadingContainer.js';
import { SkeletonLoaderV3 as SkeletonLoaderMemoized } from '../../../../Loader/SkeletonV3/SkeletonLoader.js';

var IconLoadingContainer = function IconLoadingContainer(props) {
  var content = useIconLoadingContainer(props);
  return /*#__PURE__*/React.createElement("span", content.style, /*#__PURE__*/React.createElement("span", content.contentStyle, props.children), /*#__PURE__*/React.createElement("span", content.skeletonContainerStyle, /*#__PURE__*/React.createElement(SkeletonLoaderMemoized, content.skeletonProps)));
};

export { IconLoadingContainer };
//# sourceMappingURL=IconLoadingContainer.js.map
